var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTextField(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#595959"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 11.492H.75c-.414 0-.75-.314-.75-.7v-7c0-.387.336-.7.75-.7h1.125M4.875 3.092h6.375c.414 0 .75.313.75.7v7c0 .386-.336.7-.75.7H4.875M1.5 13.067L5.25 13.067M3.375.933L3.375 13.067M1.5.933L5.25.933",
    transform: "translate(-153 -396) translate(121 385) translate(32 11) translate(1)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextField);
export default __webpack_public_path__ + "static/media/text-field.c407edc8.svg";
export { ForwardRef as ReactComponent };